import { render, staticRenderFns } from "./DropDownLink.vue?vue&type=template&id=24b9d193&"
import script from "./DropDownLink.vue?vue&type=script&lang=js&"
export * from "./DropDownLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports